module.exports = __webpack_public_path__ + "img/offers.65357b68.svg";